import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ExportOutlined } from '@ant-design/icons';

import { Table, Space } from 'antd';

import useDatasource from '../../hooks/useDatasource';
import Column from '../../helpers/columns';
import {
  findAll,
  downloadAll,
} from '../../services/validators/inspector-devices';
import ExportEntitiesButton from '../buttons/ExportEntitiesButton';
import PageTitle from '../PageTitle';

const InspectorDevicesList = () => {
  const { t } = useTranslation();

  const { pagination, criterias, content, handleChange, sort } =
    useDatasource(findAll);

  const columns = useMemo(
    () => [
      {
        title: '',
        key: 'actions',
        fixed: 'right',
        align: 'center',
        width: 40,
        render: (_, record) => {
          const lat = record?.gpsLatitude;
          const lng = record?.gpsLongitude;
          const canOpen =
            lat != null &&
            lng != null &&
            !Number.isNaN(+lat) &&
            !Number.isNaN(+lng);

          if (canOpen && +lat === 0 && +lng === 0) return null;

          const openMap = (e) => {
            e.stopPropagation();
            if (!canOpen) return;
            const url = `https://www.google.com/maps?q=${encodeURIComponent(
              lat,
            )},${encodeURIComponent(lng)}`;
            window.open(url, '_blank', 'noopener,noreferrer');
          };

          return (
            <button
              type="button"
              onClick={openMap}
              disabled={!canOpen}
              title={canOpen ? 'Open location' : 'No coordinates'}
              style={{
                border: 'none',
                background: 'transparent',
                padding: 0,
                lineHeight: 1,
                cursor: canOpen ? 'pointer' : 'not-allowed',
              }}
            >
              <ExportOutlined
                style={{ fontSize: 16, color: canOpen ? '#1677ff' : '#999' }}
              />
            </button>
          );
        },
      },
      Column.text('serialNo', t('components.inspectors.gpsLocation.serialNo'), {
        filter: true,
      }),
      Column.text(
        'inspectorId',
        t('components.inspectors.gpsLocation.inspectorId'),
        { filter: true },
      ),
      Column.text(
        'inspectorFullname',
        t('components.inspectors.gpsLocation.inspectorFullname'),
        { filter: true },
      ),
      Column.text(
        'softwareVersion',
        t('components.inspectors.gpsLocation.softwareVersion'),
        { filter: true },
      ),
      Column.text(
        'gpsLatitude',
        t('components.inspectors.gpsLocation.gpsLatitude'),
        { filter: true },
      ),
      Column.text(
        'gpsLongitude',
        t('components.inspectors.gpsLocation.gpsLongitude'),
        { filter: true },
      ),
      {
        ...Column.date(
          'updatedAt',
          t('components.inspectors.gpsLocation.updatedAt'),
          { filter: true },
        ),
        ellipsis: true,
      },
    ],
    [t],
  );

  return (
    <>
      <PageTitle>
        <Space>
          <ExportEntitiesButton
            columns={columns}
            data={{
              sort,
              criterias,
            }}
            downloadFiles={downloadAll}
          />
        </Space>
      </PageTitle>
      <Table
        rowKey="id"
        columns={columns}
        pagination={pagination}
        dataSource={content}
        onChange={handleChange}
        scroll={{ x: 700, y: 700 }}
        size="small"
      />
    </>
  );
};

export default InspectorDevicesList;
